import React from 'react'
import { useHistory } from 'react-router-dom'
import GameCard from './GameCard'
import styles from '../Games.module.css'

/** A horizontally-scrollable row of up to ~20 games. Heading/See-all link to a dedicated,
 * paginated page for that vertical - `linkTo` is a /games/:category-style slug (can be a real
 * category like "arcade" or a pseudo one like "featured"/"new-games"). */
const GameRow = ({ title, linkTo, games, onSelectGame }) => {
  const history = useHistory()

  if (!games?.length) return null

  const goToPage = (e) => {
    e?.preventDefault()
    history.push(`/games/${linkTo}`)
  }

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <button className={styles.sectionTitle} onClick={goToPage}>
          {title}
        </button>
        <a className={styles.sectionLink} href={`/games/${linkTo}`} onClick={goToPage}>
          See all
        </a>
      </div>
      <div className={styles.row}>
        {games.map((game) => (
          <GameCard key={game.subdomain} game={game} onClick={onSelectGame} />
        ))}
      </div>
    </div>
  )
}

export default GameRow
